import {filter, forEach, groupBy, map, sortBy} from "lodash";

export const generateCategoryTree = (categories) => {
  if(!categories.length) return;

  let categoryGroupLevel = groupBy(sortBy(categories,'level'),'level') //{1:[] ,2: []}

  let resultArray:any = [];

  forEach(categoryGroupLevel,(list,key)=>{
    if(!key) return;
    let mappedCategory = map(list,catObj => {
      catObj.value = catObj._id;
      catObj.label = catObj.name;
      catObj.children = filter(categories,data => {return data.parent == catObj._id})
      return catObj;
    })
    if(key == "1")
      resultArray = [...resultArray,...mappedCategory]
  })

  return resultArray;

}